
import { useTranslation } from 'react-i18next';
import CommonModal from '../common/CommonModal';
import { CirclePicker } from 'react-color';
import {
  Button,

  Input,

} from 'reactstrap';
import { CrmControlStatus } from '../../../../types/Control';

type StatusEditorModalProps = {
  modalData: {
    isOpen: boolean;
    center?: boolean;
    toggler: () => void;
  };

  selectedStatus: { id: number; statusName: string; colorCode: string } | null;
  onSave: (payload: {
    status: { id: number; statusName: string; colorCode: string } | null;
    name: string;
    color: string;
  }) => void;
  onDelete?: () => void;
  onCancel?: () => void;
  crmControlStatuses: CrmControlStatus[] | undefined;

  validationError: string;
  name: string;
  setName: (name: string) => void;
  color: string;
  setColor: (color: string) => void;
  // handleSaveEditStatus: () => void;
  // handleSaveNewStatus: () => void;
};

export const StatusEditorModal: React.FC<StatusEditorModalProps> = ({
  modalData,
  selectedStatus,
  onSave,
  onDelete,
  onCancel,
  validationError,
  name,
  setName,
  color,
  setColor,

}) => {
  const { t } = useTranslation();


  return (
    <CommonModal modalData={modalData}>
      <div className="modal-toggle-wrapper">
        {/* <h5 className="mb-3">{t('exams.totalLeaderBoard.filteredTable.addNewAction')}</h5> */}
        <div className="mb-3">
          <label className="form-label" htmlFor="new-action-name">
            {t('global.selector.nameNewStatus')}
          </label>
          <Input
            id="new-action-name"
            className="w-100"
            placeholder={t('global.selector.nameNewStatus')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="mb-3 d-flex justify-content-center">
          <div className="zono-circle-picker">
            <style>{`
                              .zono-circle-picker .circle-picker{display:flex;flex-wrap:wrap;gap:8px;justify-content:center}
                              .zono-circle-picker .circle-picker span{width:30px;height:30px;display:inline-block;margin-right:10px;margin-bottom:10px}
                              .zono-circle-picker .circle-picker span > div{width:100%;height:100%;border-radius:50%}
                            `}</style>
            <CirclePicker
              color={color}
              onChangeComplete={(c) => {
                setColor(c.hex);
              }}
              circleSize={30}
              circleSpacing={10}
              width={'400px'}
              height={'110px'}
            />
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label" htmlFor="new-status-color">
            {t('global.selector.colorHex')}
          </label>
          <Input
            id="new-status-color"
            value={color}
            onChange={(e) => setColor(e.target.value)}
            className="mt-2"
            placeholder="#ffffff"
          />
        </div>
        {validationError ? <div className="text-danger mb-2">{validationError}</div> : null}
        <div className="d-flex justify-content-start" style={{ gap: 8 }}>
          <Button
            color="primary"
            onClick={() => {
              onSave({
                status: selectedStatus,
                name: name,
                color: color,
              });
            }}
          >
            {t('global.ok')}
          </Button>
          <Button color="secondary" onClick={onCancel}>
            {t('global.cancel')}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};
